/** Canonical origin. bybw-wed-invites.nl serves the same app, so canonicals always point here. */
export const SITE_URL = 'https://handfastly.com';

/**
 * Public marketing pages that search engines may index. `key` selects the
 * `seo.<key>.title|description` strings; `ownTitle` pages set their title themselves.
 */
const INDEXABLE = {
  '/': { key: 'home' },
  '/pricing': { key: 'pricing' },
  '/demo': { key: 'demo' },
  '/demo/live': { key: 'demoLive' },
  '/privacy': { key: 'privacy', ownTitle: true },
  '/terms': { key: 'terms', ownTitle: true },
  '/refunds': { key: 'refunds', ownTitle: true },
};

/**
 * @param {string} pathname
 * @returns {{ indexable: boolean, key: string|null, ownTitle: boolean, canonical: string|null }}
 */
export function resolveRouteMeta(pathname) {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const page = INDEXABLE[path];
  if (!page) return { indexable: false, key: null, ownTitle: false, canonical: null };
  return { indexable: true, key: page.key, ownTitle: Boolean(page.ownTitle), canonical: `${SITE_URL}${path}` };
}
